import { FC } from "react";

import { DashBoardProject } from "../DashBoardProject";
import { IssuesSummary } from "../IssuesSummary";
import { MilestonesSummary } from "../MilestonesSummary";

const reportMap = new Map<string, FC<any>>([
    ["ProjectSummary", DashBoardProject],
    ["MilestoneSummary", MilestonesSummary],
    ["IssueSummary", IssuesSummary],
]);

export const getReportTemplate = (reportId: string|undefined) => {
    if (!reportId) {
        return NoReportFound;
    }

    const ReportComponent = reportMap.get(reportId);

    if (!ReportComponent) {
        return NoReportFound;
    }

    return ReportComponent;
};

const NoReportFound = () => {
    return <div>Report type not found</div>;
};
